export const authTypeConstants = {
    USER: 'user',
    ADMIN: 'admin',
    SYSTEM: 'system',
    GUEST: 'guest',
};
